import Avatar_1  from "assets/icons/avatar-1.svg";
import Avatar_2  from "assets/icons/avatar-2.svg";
import Avatar_3  from "assets/icons/avatar-3.svg";
import Avatar_4  from "assets/icons/avatar-4.svg";
import Avatar_5  from "assets/icons/avatar-5.svg";
import Send_Btn_1 from "assets/icons/botIcon-1.svg";
import Send_Btn_2 from "assets/icons/botIcon-2.svg";
import Send_Btn_3 from "assets/icons/botIcon-3.svg";
import Send_Btn_4 from "assets/icons/botIcon-4.svg";



export const bots = [
  {
    id: 1,
    name: 'Bot-Avatar-1',
    src:Avatar_1,
    data: <svg aria-hidden="true" id="search-magnify" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className="h-7 w-7"><path d="m0 272.499v51.2c0 14.138 11.462 25.6 25.6 25.6h8.533v-102.4h-8.533c-14.138 0-25.6 11.462-25.6 25.6z" fill="currentColor"></path><path d="m486.4 246.899h-8.533v102.4h8.533c14.138 0 25.6-11.462 25.6-25.6v-51.2c0-14.138-11.461-25.6-25.6-25.6z" fill="currentColor"></path><path d="m298.667 50.632c-.052 20.258-14.296 37.707-34.133 41.813v43.52h-17.067v-43.52c-21.999-4.49-36.753-25.262-33.75-47.512s22.737-38.366 45.139-36.863 39.806 20.11 39.811 42.562z" fill="currentColor"></path><circle cx="358.4" cy="272.499" fill="currentColor" r="25.6"></circle><circle cx="153.6" cy="272.499" fill="currentColor" r="25.6"></circle><path d="m409.6 153.033h-307.2c-28.277 0-51.2 22.923-51.2 51.2v187.733c0 28.207 22.814 51.101 51.021 51.2 2.289-.03 4.495.854 6.13 2.456s2.565 3.789 2.583 6.078v43.785c-.004 3.149 1.728 6.045 4.504 7.532s6.146 1.324 8.765-.424l84.864-56.559c2.793-1.862 6.073-2.86 9.429-2.867h191.104c28.277 0 51.2-22.923 51.2-51.2v-187.735c0-28.276-22.923-51.199-51.2-51.199zm-256 162.133c-23.564 0-42.667-19.103-42.667-42.667s19.103-42.667 42.667-42.667 42.667 19.103 42.667 42.667c-.029 23.553-19.115 42.639-42.667 42.667zm152.303 30.122c-.538.862-13.594 21.077-49.903 21.077s-49.365-20.215-49.903-21.077c-2.417-3.972-1.209-9.147 2.715-11.639s9.122-1.385 11.689 2.491c.512.734 9.438 13.158 35.499 13.158 26.291 0 35.149-12.638 35.507-13.175 2.61-3.872 7.83-4.959 11.767-2.449 3.908 2.5 5.079 7.676 2.629 11.614zm52.497-30.122c-23.564 0-42.667-19.103-42.667-42.667s19.103-42.667 42.667-42.667 42.667 19.103 42.667 42.667c-.029 23.553-19.115 42.639-42.667 42.667z" fill="currentColor"></path></svg>
  },
  {
    id: 2,
    name: 'Bot-Avatar-2',
    src:Avatar_2,
    data: <svg aria-hidden="true" id="search-magnify" viewBox="5 7 45 45" xmlns="http://www.w3.org/2000/svg" className="h-7 w-7"><path d="M41.18 17.86a52.75 52.75 0 0 0-19 0c-.54.1-7.9 2.7-7.9 2.7h.01c-2.9 1.01-4.91 3.75-4.91 6.9v4.85c0 2.96 1.78 5.56 4.4 6.7l17.91 8.93v-6.67c3.18 0 6.36-.29 9.5-.86 4.13-.76 7.13-4.36 7.13-8.56v-5.44c-.01-4.19-3.01-7.79-7.14-8.55zm3.47 14c0 2.43-1.74 4.52-4.13 4.95-2.91.53-5.88.8-8.84.8s-5.93-.27-8.84-.8c-2.39-.44-4.13-2.52-4.13-4.95v-5.44c0-2.43 1.74-4.52 4.13-4.95 2.91-.53 5.88-.8 8.84-.8s5.93.27 8.84.8c2.39.44 4.13 2.52 4.13 4.95v5.44z" fill="currentColor"></path><path d="M26.17 32.79c-.84 0-1.53-.68-1.53-1.53v-4.24c0-.84.68-1.53 1.53-1.53s1.53.68 1.53 1.53v4.24c-.01.85-.69 1.53-1.53 1.53zM37.17 32.79c-.84 0-1.53-.68-1.53-1.53v-4.24c0-.84.68-1.53 1.53-1.53s1.53.68 1.53 1.53v4.24c0 .85-.68 1.53-1.53 1.53z" fill="currentColor"></path></svg>
  },
  {
    id: 3,
    name: 'Bot-Avatar-3',
    src: Avatar_3,
    data: <svg aria-hidden="true"   id="search-magnify" version="1.1" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg" className="h-7 w-7"><path d="M30,1.5c-16.542,0-30,12.112-30,27c0,5.204,1.646,10.245,4.768,14.604c-0.591,6.537-2.175,11.39-4.475,13.689  c-0.304,0.304-0.38,0.769-0.188,1.153C0.275,58.289,0.625,58.5,1,58.5c0.046,0,0.092-0.003,0.139-0.01  c0.405-0.057,9.813-1.411,16.618-5.339C21.621,54.71,25.737,55.5,30,55.5c16.542,0,30-12.112,30-27S46.542,1.5,30,1.5z M16,32.5  c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S18.206,32.5,16,32.5z M30,32.5c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4  S32.206,32.5,30,32.5z M44,32.5c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S46.206,32.5,44,32.5z" fill="currentColor"></path></svg>
  },
  {
    id: 4,
    name: 'Bot-Avatar-4',
    src: Avatar_4,
    data:<svg aria-hidden="true" version="1.1" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg" className="h-7 w-7"><path d="M55.894,37.041C58.582,33.27,60,28.912,60,24.414C60,11.504,48.337,1,34,1c-8.246,0-15.969,3.592-20.824,9.42   C17.021,8.613,21.38,7.586,26,7.586c15.439,0,28,11.4,28,25.414c0,5.506-1.945,10.604-5.235,14.77   c4.946,1.886,9.853,2.601,10.096,2.635c0.047,0.007,0.094,0.01,0.14,0.01c0.375,0,0.724-0.211,0.895-0.554   c0.192-0.385,0.117-0.85-0.188-1.153C57.753,46.753,56.403,42.618,55.894,37.041z" fill="currentColor"></path><path d="M26,9.586C11.663,9.586,0,20.09,0,33c0,4.498,1.418,8.855,4.106,12.627c-0.51,5.577-1.859,9.712-3.813,11.666   c-0.304,0.304-0.38,0.769-0.188,1.153C0.275,58.789,0.625,59,1,59c0.046,0,0.092-0.003,0.139-0.01   c0.35-0.049,8.433-1.213,14.317-4.586c3.33,1.334,6.875,2.01,10.544,2.01c14.337,0,26-10.504,26-23.414S40.337,9.586,26,9.586z    M13,37c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S15.206,37,13,37z M26,37c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4   S28.206,37,26,37z M39,37c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S41.206,37,39,37z" fill="currentColor"></path></svg>
  },
  {
    id: 5,
    name: 'Bot-Avatar-5',
    src: Avatar_5,
    data:<svg aria-hidden="true" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className="h-7 w-7"><path d="M256,0C114.509,0,0,114.496,0,256c0,141.489,114.496,256,256,256c141.491,0,256-114.496,256-256    C512,114.511,397.504,0,256,0z M256,476.279c-121.462,0-220.279-98.816-220.279-220.279S134.538,35.721,256,35.721    S476.279,134.537,476.279,256S377.462,476.279,256,476.279z" fill="currentColor"></path><path d="M256.006,213.397c-15.164,0-25.947,6.404-25.947,15.839v128.386c0,8.088,10.783,16.174,25.947,16.174    c14.49,0,26.283-8.086,26.283-16.174V229.234C282.289,219.8,270.496,213.397,256.006,213.397z" fill="currentColor"></path><path d="M256.006,134.208c-15.501,0-27.631,11.12-27.631,23.925c0,12.806,12.131,24.263,27.631,24.263    c15.164,0,27.296-11.457,27.296-24.263C283.302,145.328,271.169,134.208,256.006,134.208z" fill="currentColor"></path></svg>
  },
];

export const composer = [
  {
    id: 1,
    name: 'composer-btn-1',
    src: Send_Btn_1,
  },
  {
    id: 2,
    name: 'composer-btn-2',
    src:Send_Btn_2,
  },
  {
    id: 3,
    name: 'composer-btn-3',
    src: Send_Btn_3,
  },
  {
    id: 4,
    name: 'composer-btn-4',
    src: Send_Btn_4,
  },
  {
    id: 5,
    name: 'composer-btn-5',
    src: Avatar_5,
  },
];



export function getImageSrc(name) {
  const bot = bots.find((bot) => bot.name === name);
  return bot ? bot.data : null;
}




export function getComposerIcon(name) {
  const img = composer.find((src) => src.name === name);
  return img ? img.src : name;
}






